import { z } from 'zod';

export const trancheModelSchema = z.object({
  expiryDate: z.string(),
  balance: z.number(),
});

export const accrualModelSchema = z.object({
  amount: z.number(),
  transactionDate: z.string(),
});

export const pointsSummaryModelSchema = z.object({
  id: z.string(),
  type: z.literal('points_summary'),
  attributes: z.object({
    pointsBalance: z.number(),
    accruals: z.array(accrualModelSchema),
    tranches: z.array(trancheModelSchema),
  }),
});

export const pointsSummaryResponseSchema = z.object({
  data: pointsSummaryModelSchema,
});
